module.exports = __webpack_public_path__ + "img/Size=20, Style=solid.1173f11a.svg";